// Make non-https links absolute
export function getValidUrl(url) {
  // Don't add protocol to fragment-only URLs
  if (url.startsWith('#')) {
    return url;
  }

  if (!/^(f|ht)tps?:\/\//i.test(url) && !url.startsWith('mailto:')) {
    return `https://${url}`;
  }

  return url;
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/utils/url.js